
export function NavigationButtons({ layoutType, onBack, onNext, onDone, disabled, currentStep, stepsSize, isAdmin }) {
    if (isAdmin) disabled = false
    return (<>
        <div className="text-center bg-primary-container p-2">
            {layoutType === 'Wizard Layout' && (
                <>
                    {currentStep > 1 && <button className="btn" onClick={onBack} >Back</button>}
                    {(currentStep === stepsSize) ?
                        <button className="btn mx-2" onClick={onDone} disabled={disabled}>Done</button>
                        :
                        <button className="btn mx-2" onClick={onNext} disabled={disabled}>Next</button>
                    }
                </>
            )}
            {layoutType === 'Form Layout' && (
                <button className="btn" onClick={onDone} disabled={disabled}>Submit</button>
            )}
        </div>
    </>
    );
}